import { RolCallCenter } from "src/app/hojas-call-center/models/RolCallCenter";
/*
    Clase que define las propiedades de un rol de usuario de aplicación web
    * nombre_rol: nombre del rol
    * datos_carga: datos específicos del rol
    * - El array del JSON que llega, variará dependiendo de la aplicacion y de sus necesidades
    * - Para cada aplicación que deba usarlo, se deberá de definir sus propiedades especificas
    * Conforme haya nuevos roles y definiciones, se tendrá que generar una función
    * que haga de constructor para ellos. Ver caso de RolCallCenter
*/
export class RolUsuarioAplicacion
{
    public nombre_rol:string = "";
    public datos_carga:any={};

    constructor(){}

    /*
        * Genera un objeto RolCallCenter a partir de un objeto RolUsuarioAplicacion

        * @param rolO: RolUsuarioAplicacion del que se desea generar un RolCallCenter
        * @return RolCallCenter: RolCallCenter generado a partir de RolUsuarioAplicacion
    */
    static rolCallCenter(rolO:RolUsuarioAplicacion):RolCallCenter
    {
        try
        {
            let datosCarga = JSON.parse(rolO.datos_carga);
            return new RolCallCenter(
              datosCarga.piloto || [],
              datosCarga.token_buscador || false,
              datosCarga.showBotones || {},
              rolO
            );
        }
        catch(e)
        {
            console.error("Error al parsear datos_carga: ");
            console.error(e);
            return new RolCallCenter([],false,rolO);
        }
    }
}
